import { Stack, Typography } from "@mui/material";
import { HomeBroadbandWhyBlock } from "@features/home/broadband/HomeBroadbandWhyBlock";
import MobileCheckIcon from "@static/icons/Check.svg";
import MobileSimIcon from "@static/icons/Sim.svg";
import MobilePhoneIcon from "@static/icons/Phone.svg";
import MobilePaperPlaneIcon from "@static/icons/PaperPlane.svg";
import { useDeviceType } from "@hooks/useDeviceType";
import { useTranslation } from "react-i18next";
import { useStyle } from "@features/home/mobile/HomeMobileSwitchEasy/style";

export const HomeMobileSwitchEasy = () => {
    const { isMobileOrTablet } = useDeviceType();
    const { t } = useTranslation("home");
    const { classes } = useStyle();

    return (
        <Stack bgcolor={isMobileOrTablet ? "background.light" : "background.main"} justifyContent="center" width="100%">
            <div className={classes.container}>
                <Typography align="center" variant="h2">
                    {t("mobileSwitchEasy.title")}
                </Typography>
                <div className={classes.blockContainer}>
                    <HomeBroadbandWhyBlock
                        description={t("mobileSwitchEasy.selectPlan.description")}
                        getBackgroundColor={(theme) => theme.palette.primary.main}
                        getIconColor={(theme) => theme.palette.background.light ?? theme.palette.primary.main}
                        isCompactLayout={isMobileOrTablet}
                        svgIcon={MobileCheckIcon}
                        title={t("mobileSwitchEasy.selectPlan.title")}
                    />
                    <HomeBroadbandWhyBlock
                        description={t("mobileSwitchEasy.orderSIM.description")}
                        getBackgroundColor={(theme) => theme.palette.primary.main}
                        getIconColor={(theme) => theme.palette.background.light ?? theme.palette.primary.main}
                        isCompactLayout={isMobileOrTablet}
                        svgIcon={MobileSimIcon}
                        title={t("mobileSwitchEasy.orderSIM.title")}
                    />
                    <HomeBroadbandWhyBlock
                        description={t("mobileSwitchEasy.moveNumber.description")}
                        getBackgroundColor={(theme) => theme.palette.primary.main}
                        getIconColor={(theme) => theme.palette.background.light ?? theme.palette.primary.main}
                        isCompactLayout={isMobileOrTablet}
                        svgIcon={MobilePhoneIcon}
                        title={t("mobileSwitchEasy.moveNumber.title")}
                    />
                    <HomeBroadbandWhyBlock
                        description={t("mobileSwitchEasy.activateAccount.description")}
                        getBackgroundColor={(theme) => theme.palette.primary.main}
                        getIconColor={(theme) => theme.palette.background.light ?? theme.palette.primary.main}
                        isCompactLayout={isMobileOrTablet}
                        svgIcon={MobilePaperPlaneIcon}
                        title={t("mobileSwitchEasy.activateAccount.title")}
                    />
                </div>
            </div>
        </Stack>
    );
};
